
/**
 * Like scrollIntoView but only scroll horizontally.
 *
 * @param {object} element The element to scroll.
 * @param {object} container The container to scroll within.
 * @return {void}
 */
const scrollToCenter = function( element, container ) {

	const elementCenter = element.offsetLeft + ( element.clientWidth / 2 );
	const containerWidth = container.clientWidth;

	container.scrollLeft = elementCenter - ( containerWidth / 2 );

};


/**
 * Like scrollIntoView but only scroll vertically.
 *
 * @param {object} element The element to scroll.
 * @param {object} container The container to scroll within.
 * @return {void}
 */
const scrollToTop = function( element, container ) {

	const elementTop = element.offsetTop;
	const containerTop = container.offsetTop;

	container.scrollTop = elementTop - containerTop;

};